<script setup lang="ts">
import { ConfigProvider } from 'radix-vue'
import { Toaster } from '@/components/ui/sonner'

const useIdFunction = () => useId()

const { $pwa } = useNuxtApp()
const $router = useRouter()
const showInAppBrowsingWaning = ref<boolean>(false)
const isUpdatingServiceWorker = ref<boolean>(false)
const needRefresh = computed(() => $pwa?.needRefresh ?? false)

async function updateServiceWorker() {
  isUpdatingServiceWorker.value = true
  await $pwa?.updateServiceWorker(true)
  // deleteAllCookies()
  isUpdatingServiceWorker.value = false
  $router.push('/')
}

// function deleteAllCookies() {
//   document.cookie.split(';').forEach((cookie) => {
//     const eqPos = cookie.indexOf('=')
//     const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
//     document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
//   })
// }

onMounted(() => {
  if (navigator.userAgent.includes('Instagram'))
    showInAppBrowsingWaning.value = true
})
</script>

<template>
  <ConfigProvider :use-id="useIdFunction">
    <div id="app" class="flex flex-col justify-center relative device-min-h-full md:mx-auto">
      <NuxtPwaManifest />
      <NuxtLayout>
        <!-- <NuxtLoadingIndicator color="#94a3b8" :height="4" /> -->
        <NuxtPage />
      </NuxtLayout>

      <common-login-hint />
    </div>

    <client-only>
      <Toaster position="top-center" />

      <ui-drawer v-model:open="showInAppBrowsingWaning">
        <ui-drawer-content class="pb-safe">
          <ui-drawer-header>
            <ui-drawer-title>
              <p class="py-4 text-base font-bold text-center">
                您目前使用的是嵌入式瀏覽器
              </p>
            </ui-drawer-title>
            <ui-drawer-description>
              <p class="text-base text-center px-8">
                如需登入，請改用原生瀏覽器如Safari或是Google Chrome開啟本網站
              </p>
            </ui-drawer-description>
          </ui-drawer-header>

          <div class="mt-4 px-6 pb-12">
            <ui-button
              class="py-4 w-full h-auto rounded-full"
              @click="$router.go(-1)"
            >
              <i
                i-flat-color-icons-google
                class="inline-block mr-2 scale-150"
              />
              <span class="ml-2">回上一頁</span>
            </ui-button>
          </div>
        </ui-drawer-content>
      </ui-drawer>

      <ui-drawer :open="needRefresh">
        <ui-drawer-content class="pb-safe">
          <ui-drawer-header>
            <ui-drawer-title>
              <p class="py-4 text-base font-bold text-center">
                網站版本更新
              </p>
            </ui-drawer-title>
            <ui-drawer-description>
              <p class="px-8 text-base text-center">
                發現較新版本，請按確定以進行更新
              </p>
            </ui-drawer-description>
          </ui-drawer-header>

          <div class="mt-4 px-6 pb-12">
            <ui-button
              class="w-full py-4 h-auto rounded-full"
              @click="updateServiceWorker"
            >
              <template v-if="isUpdatingServiceWorker">
                <i i-ph-spinner class="mr-2 !w-4 !h-4 animate-spin !text-dark" />
                <span>更新中</span>
              </template>
              <template v-else>
                <span>確定</span>
              </template>
            </ui-button>
          </div>
        </ui-drawer-content>
      </ui-drawer>
    </client-only>
  </ConfigProvider>
</template>
